import Vue from 'vue'
import apiList from '@/service/apiList'
// import { Message } from 'element-ui'

// 非系统通知返回订单信息
function courierListStatus (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.post(apiList.courierListStatus, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 非系统通知物流承运商列表
function customExpressList (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.get(apiList.customExpressList, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 系统通知转非系统通知
function orderCourierUpdate (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.post(apiList.orderCourierUpdate, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 系统通知转非系统通知
function saveNotSystemLogisticsByOrder (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.post(apiList.saveNotSystemLogisticsByOrder, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 物流状态
function courierStatusQuery (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.post(apiList.courierStatusQuery, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}

export {
  courierListStatus, customExpressList, orderCourierUpdate, courierStatusQuery, saveNotSystemLogisticsByOrder
}



// WEBPACK FOOTER //
// ./src/models/ts.js